import { ChevronsUpDown, LogOut, Settings2, User } from "lucide-react";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { UserRoleLabes } from "../auth/components/UserProfileCard";
import { useNavigate } from "react-router-dom";

interface SidebarUserMenuProps {
  isCollapsed: boolean;
}

const SidebarUserMenu: React.FC<SidebarUserMenuProps> = ({ isCollapsed }) => {
  const navigate = useNavigate();  
  const auth = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const ToProperCase = (name?: string) => {
    if (!name) return ""; 
    return name
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  if (!auth.user) return null;

  if (isCollapsed) {
    return (
      <div className="relative">
        <button
          onClick={() => setIsOpen((p) => !p)}
          className="h-8 w-8 rounded-md bg-gradient-to-br from-pink-400 to-purple-500 flex items-center justify-center flex-shrink-0 overflow-hidden cursor-pointer hover:opacity-90 transition-opacity"
        >
          <User className="h-4 w-4 text-white" />
        </button>

        {isOpen && (
          <div className="absolute left-0 bottom-full w-[194px] rounded-[8px]  shadow-xl bg-white border border-[#E5E5E5] p-1 z-30">
            <button className="w-full text-[#0A0A0A]  text-left px-3 py-2 text-sm flex rounded-[6px] items-center hover:bg-[#F5F5F5]"
              onClick={() => {
                setIsOpen(false);
                navigate("/settings");
            }}>
              <Settings2 className="h-4 w-4 mr-2" />
              Settings
            </button>

            <button
              className="w-full text-[#0A0A0A]  text-left px-3 py-2 text-sm flex items-center rounded-[6px] hover:bg-[#F5F5F5]"
              onClick={() => auth.signoutRedirect()}
            >
              <LogOut className="h-4 w-4 mr-2" />
              Log out
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="relative w-full">
      <button
        onClick={() => setIsOpen((p) => !p)}
        className="flex  text-left items-center w-full gap-2 px-2 py-2 rounded-md hover:bg-gray-100 cursor-pointer transition-colors"
      >
        <div className="h-8 w-8 rounded-md bg-gradient-to-br from-pink-400 to-purple-500 flex items-center justify-center flex-shrink-0 overflow-hidden">
          <User className="h-4 w-4 text-white" />
        </div>

        <div className="flex flex-col flex-1 min-w-0 gap-0.5 justify-center items-start">
          <span className="text-sm font-semibold leading-none text-gray-900 truncate">
            {ToProperCase(auth.user.profile.name)}
          </span>

          <span className="text-xs font-normal leading-none text-gray-500 truncate">
            {
              UserRoleLabes[
                (auth.user.profile.realm_access as any)?.roles[0] as string
              ]
            }
          </span>
        </div>

        <ChevronsUpDown className="h-4 w-4 text-gray-500 flex-shrink-0" />
      </button>

      {isOpen && (
        <div className="absolute -right-[57px] bottom-[48px] w-[194px] bg-white border border-[#E5E5E5]  rounded-[8px] shadow-xl p-1 z-30">
          <button className="w-full text-[#0A0A0A] text-left px-3 py-2 text-sm flex items-center rounded-[6px] hover:bg-[#F5F5F5]"
              onClick={() => {
                setIsOpen(false);
                navigate("/settings");
            }}>          
            <Settings2 className="h-4 w-4 mr-2" />
            Settings
          </button>

          <button
            className="w-full text-[#0A0A0A] text-left px-3 py-2 text-sm flex items-center rounded-[6px] hover:bg-[#F5F5F5]"
            onClick={() => auth.signoutRedirect()}
          >
            <LogOut className="h-4 w-4 mr-2" />
            Log out
          </button>
        </div>
      )}
    </div>
  );
};

export default SidebarUserMenu;

